import { t } from 'i18next';
import CustomButtonColor from '../../Components/custom-button/CustomButtonColor';
import './CardValueOld.css';
import { nextStep } from '../../Services/api-service';
import { isNullOrEmpty, removeDotFromStringMoney } from '../../Services/service';
function CardValueProductWidgetOld ({id, objectDto, selected, setObjectDto, setIsLoading}) {
    function handleClick () {
        setIsLoading(true);
        var db = {
            ...objectDto, 
            productId: selected.productId, 
            productName: selected.productName, 
            description: selected.description,
            productCode: selected.productCode,
            discountRate: selected.discountRate,
            maleRate: selected.maleRate,
            femaleRate: selected.femaleRate,
            clientFlag: selected.clientFlag,  
            frequency: selected.frequency, 
            policyTerm: selected.policyTerm,
            premiumFemale: selected.premiumFemale,
            premiumMale: selected.premiumMale,
            premium: objectDto.gender === 0 ? selected.premiumMale : selected.premiumFemale,
            premiumOrigin: objectDto.gender === 0 ? selected.premiumOriginMale : selected.premiumOriginFemale,
            strSumAssured: selected.strSumAssured,
            sumAssured: selected.sumAssured
        };
        nextStep(db, setObjectDto, setIsLoading);
    }
    // fix money, if remove "dong" then remove this func
    const splitSpaceMoney = (money) => {
        if(isNullOrEmpty(money)) return "";
        return money.split(" ")[0];
    }
    return (
        <div className="card-value-product" key={id}>
            <div className="title-card-value product-title-card">
                <label>{selected.productName}</label>
            </div>
            <p className='title-money-policy product-title-card-label'>{t("moneypolicy")}</p>
            <div className="money-card-value product-title-card">
                <label>{splitSpaceMoney(selected.strSumAssured)}</label>
            </div>
            <div className="money-card-value product-title-card">
                <label>{t("vnd")}</label>
            </div>
            <p className='title-money-policy product-title-card-label'>{t("feepolicy")}</p>
            {/* <div className="total-card-value product-desc-card"> */}
            <div className="total-card-value product-title-card">
                <label>{(objectDto.gender === 0 ? removeDotFromStringMoney(selected.premiumMale) : removeDotFromStringMoney(selected.premiumFemale)) + " " + t("vnd") + " " + t("peryear")}</label>
            </div>
            <CustomButtonColor bgColor={"#050509"}  color={"#ffffff !important"} title={t("buynow")}  onClick={()=>{handleClick(selected.productId)}}  /> 
        </div>
    )
}
export default CardValueProductWidgetOld;